export default "__VITE_ASSET__bmEmMAs7__"